import { GetMenuCategoriesQuery } from "@me-team/host/main/menu/graphql/menu.hooks";
import { GetMenuCategoriesForUpdateMenuItemsQuery } from "@me-team/host/main/updateMenuItem/graphql/updateMenuItem.hooks";

export const normalizeCategoryData = (data: GetMenuCategoriesQuery | GetMenuCategoriesForUpdateMenuItemsQuery) => {
    return data?.user?.company?.meMenuCategoriesPaginated?.categories || [];
};
